import { getRequest, putCall } from "../../../../helpers/fakebackend_helper";
import {
  getCareerPageDataSuccess,
  getCareerPageDataFail,
  updateCareerPageUrlSuccess,
  updateCareerPageUrlFail,
  updateCareerPageLinkSuccess,
  updateCareerPageLinkFailed,
} from "./actions";
import {
  CAREER_POPUP_DATA,
  HIDE_CAREER_POPUP_DATA,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK,
  UPDATE_CAREER_POPUP_DATA,
} from "./actionTypes";

import * as constClass from "../../../../common/constant/constantURL";
import { put, takeEvery } from "redux-saga/effects";

function* getConfigData() {
  try {
    let url = constClass.REST_API_CAREER_CONFIG_DATA;
    let responseJson = yield getRequest(url);
    yield put(getCareerPageDataSuccess(responseJson));
  } catch (error) {
    yield put(getCareerPageDataFail(error));
  }
}
function* updateCareerPageURl({ payload: url }) {
  try {
    let urlConfig = constClass.REST_API_UPDATE_CAREERPAGEURL;
    let responseJson = yield putCall(urlConfig, url.url);
    yield put(updateCareerPageUrlSuccess("Sucess"));
  } catch (error) {
    yield put(updateCareerPageUrlFail(error));
  }
}

// use for update career page integration link
function* updateCareerPageLink({ payload: data }) {
  try {
    let url = constClass.REST_API_UPDATE_INTEGRATION_CAREERPAGELINK;
    let responseJson = yield putCall(url, data.data);
    yield put(updateCareerPageLinkSuccess(responseJson));
  } catch (error) {
    yield put(updateCareerPageLinkFailed(error));
  }
}
function* hideCareerPopUP() {
  try {
    let url = constClass.REST_API_HIDE_CAREERPAGEPOPUP;
    let responseJson = yield getRequest(url + "?hidePopUp=" + false);
    yield put(getCareerPageDataSuccess(responseJson));
    let authUser = JSON.parse(localStorage.getItem("authUser"));
    console.log("before",authUser);
    authUser.showCareerPopUp = false;
    localStorage.setItem("authUser", JSON.stringify(authUser));
    console.log(authUser);
  } catch (error) {
    yield put(getCareerPageDataFail(error));
  }
}
function* CareerConfigSaga() {
  yield takeEvery(CAREER_POPUP_DATA, getConfigData);
  yield takeEvery(UPDATE_CAREER_POPUP_DATA, updateCareerPageURl);
  yield takeEvery(UPDATE_CAREER_PAGE_INTEGRATION_LINK, updateCareerPageLink);
  yield takeEvery(HIDE_CAREER_POPUP_DATA, hideCareerPopUP);
}
export default CareerConfigSaga;
